<script setup lang="ts">
import {computed, ref} from "vue";
import {EventCalendar} from "@/appointment/components/consumer-appointment-timeline/event-calendar";
import {DateValue, getLocalTimeZone, now} from "@internationalized/date";
import useAppointments from "@/appointment/composables/useAppointments";

const value = defineModel<DateValue | undefined>();
const range = ref<{ startDate: Date | null; endDate: Date | null; } | undefined>(undefined);

const {data} = useAppointments(range);

/**
 * Map the appointments for the calendar component.
 */
const calendarEvents = computed(() => {
    return data.value?.map(appointment => {
        const time = new Date(appointment.start_at).toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit'
        });

        return {
            date: new Date(appointment.start_at),
            start: new Date(appointment.start_at),
            end: new Date(appointment.end_at),
            title: appointment.title ?? 'Rendez-vous',
            time,
            description: appointment.description ?? undefined,
            color: '#2196F3',
            id: appointment.id,
            patientName: appointment.beneficiary?.name ?? appointment.customer?.name,
            operatorName: appointment.operator?.name
        };
    }) ?? [];
});
</script>

<template>
  <div class="relative h-full">
    <EventCalendar
      v-model:model-value="value"
      :events="calendarEvents ?? []"
      :min-value="now(getLocalTimeZone())"
      @date-range-changed="range = $event"
    />
  </div>
</template>
